import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';

import { Col, Container } from 'react-bootstrap';

export const SCol = styled(Col)`
  p,
  table {
    font-size: ${calcResize(14, 18)};
  }
`;

export const SContainer = styled(Container)`
  padding-top: 30px;

  h1 {
    font-size: ${calcResize(28, 30)};
  }
`;
